import React from 'react';
import ReactDOM from 'react-dom';
import { hydrateRoot } from 'react-dom/client';
import Root from './LpRoot';
import { Settings } from 'luxon';

const rootElement = document.getElementById('root');

Settings.defaultLocale = 'pt-BR';
Settings.defaultZoneName = 'America/Sao_Paulo';

if (rootElement) {
    if (rootElement.hasChildNodes()) {
        hydrateRoot(rootElement, <Root />);
    } else {
        ReactDOM.render(<Root />, rootElement);
    }
}
